// The top of every signed-in screen: the kit's PageHeader (what this is, one line on why, its
// actions) above the screen's content, in one padded column. A screen opens with this, not with a
// form (BRAND.md §6).

import { PageHeader } from '@clavian/ui-web';
import type { ReactNode } from 'react';

export interface PageProps {
  readonly title: ReactNode;
  readonly description?: ReactNode;
  readonly eyebrow?: ReactNode;
  readonly actions?: ReactNode;
  readonly meta?: ReactNode;
  readonly children: ReactNode;
}

export function Page({ title, description, eyebrow, actions, meta, children }: PageProps): ReactNode {
  return (
    <div className="pw-page">
      <PageHeader
        title={title}
        {...(description === undefined ? {} : { description })}
        {...(eyebrow === undefined ? {} : { eyebrow })}
        {...(actions === undefined ? {} : { actions })}
        {...(meta === undefined ? {} : { meta })}
      />
      {children}
    </div>
  );
}
